import { useSyncExternalStore } from "react";
import { profileImage } from "../lib/pro-identity";

/**
 * The agent's headshot (Clerk's, or the local preview stand-in), or null (no upload, or removed).
 * Reactive: the Clerk global is not React state, so the header avatar and the
 * `/profile` photo control subscribe here and re-render the moment a change
 * resolves. The snapshot is a primitive string, so unrelated Clerk state
 * changes never cause extra renders.
 */
export function useClerkImageUrl(): string | null {
  return useSyncExternalStore(profileImage.subscribe, profileImage.read, () => null);
}
